function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M149.879,103.649c11.658,0,21.105-9.849,21.105-21.976c0-12.127-9.447-21.976-21.105-21.976 c-11.658,0-21.105,9.849-21.105,21.976C128.774,93.8,138.221,103.649,149.879,103.649z M149.879,69.747 c6.097,0,11.055,5.36,11.055,11.926s-4.958,11.926-11.055,11.926c-6.097,0-11.055-5.36-11.055-11.926 S143.782,69.747,149.879,69.747z"
}), React.createElement("path", {
  d: "M182.106,103.582c2.747,0,5.025-2.278,5.025-5.025v-2.68l13.534,7.169c0.737,0.402,1.541,0.603,2.345,0.603 c1.809,0,3.551-1.005,4.422-2.814c1.34-2.412,0.402-5.494-2.077-6.767l-12.462-6.566l12.462-6.566 c1.675-0.871,2.68-2.546,2.68-4.422V64.655c0-2.747-2.278-5.025-5.025-5.025h-20.904c-2.747,0-5.025,2.278-5.025,5.025v33.902 C177.081,101.304,179.359,103.582,182.106,103.582z M187.064,69.747h10.854v3.819l-10.854,5.695V69.747z"
}), React.createElement("path", {
  d: "M95.073,95.542c3.685,5.427,9.983,8.442,16.549,8.442c2.613,0,5.293-0.536,7.906-1.608 c2.546-1.005,3.819-3.886,2.814-6.499c-1.005-2.546-3.886-3.819-6.499-2.814c-4.556,1.876-9.849,0.536-12.395-3.082 c-2.948-5.092-2.948-11.39-0.067-15.678c2.345-3.484,6.7-5.829,11.189-3.484c2.412,1.34,5.494,0.402,6.767-2.077 c1.34-2.412,0.402-5.494-2.077-6.767c-8.375-4.422-18.559-1.608-24.187,6.7c-5.025,7.504-5.092,18.224-0.134,26.599 C94.939,95.341,95.006,95.475,95.073,95.542z"
}), React.createElement("path", {
  d: "M219.09,103.649h21.708c2.747,0,5.025-2.278,5.025-5.025s-2.211-5.025-5.025-5.025h-16.683v-6.901h6.231 c2.747,0,5.025-2.278,5.025-5.025s-2.278-5.025-5.025-5.025h-6.231v-6.901h16.683c2.747,0,5.025-2.278,5.025-5.025 s-2.278-5.025-5.025-5.025H219.09c-2.747,0-5.025,2.278-5.025,5.025v33.902C214.065,101.371,216.343,103.649,219.09,103.649z"
}), React.createElement("path", {
  d: "M53.131,98.624c0,2.747,2.278,5.025,5.025,5.025h21.708c1.809,0,3.551-1.005,4.422-2.613 c0.871-1.608,0.804-3.551-0.201-5.092l-16.75-26.13h12.529c2.747,0,5.025-2.278,5.025-5.025c0-2.747-2.278-5.025-5.025-5.025 H58.156c-1.876,0-3.551,1.005-4.422,2.613c-0.871,1.608-0.804,3.551,0.201,5.092l16.75,26.13H58.156 C55.409,93.599,53.131,95.877,53.131,98.624z"
}), React.createElement("path", {
  d: "M0,37.654v224.45h299.758V37.654H0z M32.16,252.054H10.05V194.3h22.11V252.054z M32.16,184.25H10.05v-57.754h22.11 V184.25z M149.678,252.054H42.277V194.3h107.401V252.054z M149.745,184.25H42.277v-57.754h107.468V184.25z M181.838,252.054 h-22.11V194.3h22.11V252.054z M181.838,184.25h-22.11v-57.754h22.11V184.25z M213.998,252.054h-22.11V194.3h22.11V252.054z M213.998,184.25h-22.11v-57.754h22.11V184.25z M289.708,252.054h-65.593V194.3h65.593V252.054z M289.708,184.25h-65.593v-57.754 h65.593V184.25z M289.708,116.446H10.05V47.704h279.658V116.446z"
}), React.createElement("polygon", {
  points: "278.05,146.327 271.149,139.024 251.183,157.851 242.607,150.012 235.84,157.382 251.317,171.586 \t\t\t"
}), React.createElement("polygon", {
  points: "248.503,239.323 256.878,230.479 265.32,239.323 272.623,232.422 263.846,223.176 272.623,213.93  265.32,207.029 256.878,215.873 248.503,207.029 241.2,213.93 249.977,223.176 241.2,232.422 \t\t\t"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.758 299.758",
    style: {
      "enableBackground": "new 0 0 299.758 299.758"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/scoreboard.acde4780.svg";
export { SvgComponent as ReactComponent };